import {LocalDate} from '@js-joda/core';
import type {Patient, RawPatient} from '@/types/patient';

export const mapRawToPatient = (raw : RawPatient) : Patient => ({
    ...raw,
    dateOfBirth: LocalDate.parse(raw.dateOfBirth),
});
